<template>
  <b-modal id="preview-confirmation-modal" hide-footer centered hide-backdrop>
    <template slot="modal-title">
      Удаление заставки видео
    </template>
    <p class="my-1 text-center">Вы уверены, что хотите удалить заставку данного видео?</p>
    <b-row class="mt-4">
      <b-col>
        <b-button block variant="primary" @click="onDeletePreview">
          Удалить
        </b-button>
      </b-col>
      <b-col>
        <b-button block variant="outline-primary" @click="$bvModal.hide('preview-confirmation-modal')">
          Отмена
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalDeletePreview',
  methods: {
    onDeletePreview() {
      this.$emit('delete')
    }
  }
}
</script>

<style scoped>

</style>
